export const ACTIONS_SCHEDULED_JOB = {
  INVALIDATE: 'SCHEDULED_JOBS_INVALIDATE',
  RECEIVE: 'SCHEDULED_JOBS_RECEIVE',
  DELETE: 'SCHEDULED_JOB_DELETE',
  UPDATE: 'SCHEDULED_JOB_UPDATE',
};

const scheduledJobConstants = {};

export default scheduledJobConstants;
